<template>
	<div id="app">
		<header class="fix-area">
			<div class="media-area" id="1" v-html="mediaContent"></div>
			<head-bar />
			<nav-bar :navs="channels" />
		</header>
		<dataList ref="dataList" :cid="cid" />
		<transition name="zoom-in-top">
			<div @click="returnTop" class="to-top" v-show="pageTop >= 2000">
				<div class="to-top-icon"></div>
			</div>
		</transition>
	</div>
</template>
<script>
	import headBar from "./components/head";
	import navBar from "./components/nav";
	import dataList from "./components/DataList";
	import API from "./api.js";
	import { scrollAni } from "./common.js";

	export default {
		components: {
			headBar,
			navBar,
			dataList,
		},
		data() {
			return {
				scrollTimer: null,
				cid: 0,
				channels: [],
				scrollTop: {},
				pageTop: 0,
				aniTimer: null,
				mediaObj: window.afocus_adv,
				mediaContent:''
			};
		},
		methods: {
			returnTop() {
				scrollAni(document.documentElement, "scrollTop");
			},
			// 顶部广告位调取广告
			show(id) {
				var afocus_content = this.mediaObj[id];
				var afocus_type = afocus_content.type;
				var afocus_array = afocus_content.material;
				var img_dom = "";
				if (afocus_type == 1) {
					if(afocus_array[0].url!=""){
						img_dom += '<a href="' + afocus_array[0].url + '" target="_blank">';
					}else{
						img_dom += '<a>';
					}
					img_dom += '<img src="' + afocus_array[0].images + '" width="100%" height="auto" border="0"/></a>';
					this.changeTopHead();
					return img_dom;
				}
			},
			changeTopHead() {
				setTimeout(function(){
					var height = document.getElementsByClassName("fix-area")[0].offsetHeight +10;
					document.getElementById("listArea").style.paddingTop = height + 'px';
				},100)
			}
		},
		async created() {
			this.channels = await API.getChannels();
			if (!this.$route.params.channel) {
				this.$router.push(`/index/${this.channels[0].id}`).catch(() => {});
				this.cid = this.channels[0].id;
			} else {
				this.cid = +this.$route.params.channel;
			}
			this.mediaContent = this.show(1);
		},
		mounted() {
			window.addEventListener("scroll", () => {
				clearTimeout(this.scrollTimer);
				this.scrollTimer = setTimeout(() => {
					this.pageTop = document.documentElement.scrollTop;
				}, 50);
			});
		},
	};
</script>
<style lang="scss">
	html,
	body {
		font-family: "Microsoft Yahei", "Simsun", "arial";
		font-size: 16px;
		color: #222;
		-webkit-text-size-adjust: none;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	}
	html,
	body,
	div,
	p,
	ul,
	li {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}
	ul {
		list-style: none;
	}
	a,
	a:active,
	a:visited,
	a:focus {
		text-decoration: none;
		outline: 0;
	}
	::-webkit-scrollbar {
		display: none;
	}
	.fl {
		float: left;
	}
	.fr {
		float: right;
	}
	.clear {
		zoom: 1;
		&::after {
			content: "";
			display: block;
			clear: both;
		}
	}
	#app {
		max-width: 640px;
		margin: auto;
	}
	.fix-area {
		position: fixed;
		width: 100vw;
		max-width: 640px;
		top: 0;
		z-index: 100;
	}
	.to-top {
		position: fixed;
		bottom: 20vh;
		right: 5vw;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
		padding: 15px;
		background: rgba($color: #fff, $alpha: 0.8);
		border-radius: 50%;
		&:active {
			background: rgba($color: #fff, $alpha: 1);
		}
		.to-top-icon {
			position: relative;
			top: -5px;
			height: 15px;
			width: 15px;
			margin: auto;
			border: 3px solid #ff102f;
			border-color: #ff102f transparent transparent #ff102f;
			transform: rotate(45deg) translate(5px, 5px);
			&::before {
				content: "";
				position: absolute;
				background: #ff102f;
				width: 20px;
				height: 3px;
				transform: rotate(134deg) translate(-9px, 3px);
				transform-origin: center;
				top: 3px;
				left: -18px;
			}
			&::after {
				content: "";
				position: absolute;
				width: 3px;
				height: 18px;
				background: #ff102f;
				transform: rotate(134deg) translate(0.7px, 5px);
				transform-origin: center;
				left: 9px;
				top: 0px;
			}
		}
	}
	.zoom-in-top-enter-active,
	.zoom-in-top-leave-active {
		opacity: 1;
		-webkit-transform: scaleY(1);
		transform: scaleY(1);
		-webkit-transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
			-webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
		transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
			-webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
		transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
			opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1);
		transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
			opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
			-webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
		-webkit-transform-origin: center top;
		transform-origin: center top;
	}
	.zoom-in-top-enter,
	.zoom-in-top-leave-active {
		opacity: 0;
		-webkit-transform: scaleY(0);
		transform: scaleY(0);
	}
.media-area img{
	display: block;
}
.fix-area .media-area img{
	margin: 0;
}
</style>
